export default __webpack_public_path__ + "static/media/unholyhands.74eea48d.png";